import { render, staticRenderFns } from "./DIList.vue?vue&type=template&id=6008a6a0&scoped=true&"
import script from "./DIList.vue?vue&type=script&lang=js&"
export * from "./DIList.vue?vue&type=script&lang=js&"
import style0 from "./DIList.vue?vue&type=style&index=0&id=6008a6a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008a6a0",
  null
  
)

export default component.exports